module.exports = __webpack_public_path__ + "media/images/xpass/markers/inactive/rumble-5c73f17adc5146921ffb20451e4abc3e.png";